<div class="bg-overlay">
  <div>
    <div class="spinner-container" [ngClass]="getSizeClass()">
      <div class="ball"></div>
      <div class="ball"></div>
      <div class="ball"></div>
    </div>
    <div class="spinner-message">
      <ng-content></ng-content>
    </div>
  </div>
</div>
